export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5649.6df746f5.jpg";